module.exports = __webpack_public_path__ + "static/img/shibai1.7d860fac.png";